
const prefix = 'NAV_';

export const navConstants = {
    SET_TITLE: prefix + 'SET_TITLE',
};
